export default "__VITE_ASSET__BlLDfPDG__"